
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import AuthHeader from "@/components/layout/auth-header.vue";
import config from "@/config/config";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import Company from "@/lib/model/company/company";

@Component({
  components: {
    AuthHeader
  }
})
export default class NoAuth extends Vue {
  name = "no-auth";
  showRight = true;
  vuexStores = vuexStore;
  companyInfo = new Company();

  created() {
    Auth.initUser();
    this.companyInfo = this.vuexStores.company;
    setTimeout(() => {
      if (!Auth.token) {
        this.$router.push("/").catch(err => err);
      } else if (
        // parseInt(this.vuexStores.user.id) !== 0 &&
        // parseInt(this.vuexStores.user.threatDegree) <= 7 &&
        // Auth.companyId !== ""
        parseInt(this.vuexStores.user.id) !== 0 &&
        this.companyInfo.isEnableAI &&
        Auth.companyId !== ""
      ) {
        this.$router.push("/exam/paper").catch(err => err);
      }
    }, 500);
  }

  toAiHomePage() {
    window.location.href = config.aiInterviewHomepage;
  }
}
